module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--it-476e36ef5660d791797e665a609c9ed6.jpg";